// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3084":"97603068d5c14140","3722":"6902aaec39d427d1","9995":"2e3e445c4ce7a2b3"}[chunkId] + ".css";
};